import { render, staticRenderFns } from "./zq-add.vue?vue&type=template&id=f392c5d2&scoped=true&"
import script from "./zq-add.vue?vue&type=script&lang=js&"
export * from "./zq-add.vue?vue&type=script&lang=js&"
import style0 from "./zq-add.vue?vue&type=style&index=0&id=f392c5d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f392c5d2",
  null
  
)

export default component.exports